import type {
  ActiveKioskConfigDto,
  PrimaryPaletteDto,
} from '@millionshow/api-client';

export const KIOSK_SOURCE_TYPES = [
  'MILLIONSHOW',
  'ALLHOUSE',
  'STARTFAIR',
  'AGRITEX',
  'GIFTFAIR',
] as const;
export type KioskSourceType = (typeof KIOSK_SOURCE_TYPES)[number];
export type KioskRuntimeConfig = Omit<ActiveKioskConfigDto, 'sourceType'> & {
  sourceType: KioskSourceType;
};
export const KIOSK_CONFIG_CACHE_KEY = 'millionshow:kiosk-config:v1';

export const FALLBACK_KIOSK_CONFIG: KioskRuntimeConfig = {
  sourceType: 'MILLIONSHOW',
  primaryColor: '#FF6B00',
  primaryPalette: {
    50: '#FFF4EC',
    100: '#FFE8D5',
    200: '#FFD0AA',
    300: '#FFB37A',
    400: '#FF8F42',
    500: '#FF6B00',
    600: '#E55F00',
    700: '#BF4F00',
    800: '#993F00',
    900: '#732F00',
    950: '#4D1F00',
  },
  logoUrl: '/logo.svg',
  homeBackgroundUrl: '/home/main-bg.svg',
  homeHeroImageUrl: '/home/home1.svg',
  homeIntroText: '전국 11개의 시도에서 개최되는\n세븐테마박람회 밀리언쇼',
  usesDefaultHomeDesign: true,
};

const SHADES: Array<keyof PrimaryPaletteDto> = [
  '50',
  '100',
  '200',
  '300',
  '400',
  '500',
  '600',
  '700',
  '800',
  '900',
  '950',
];
const isHex = (value: unknown) =>
  typeof value === 'string' && /^#[0-9A-Fa-f]{6}$/.test(value);

export function isActiveKioskConfig(
  value: unknown
): value is KioskRuntimeConfig {
  if (!value || typeof value !== 'object') return false;
  const config = value as Record<string, unknown>;
  const palette = config['primaryPalette'] as
    | Record<string, unknown>
    | undefined;
  return (
    KIOSK_SOURCE_TYPES.includes(config['sourceType'] as KioskSourceType) &&
    isHex(config['primaryColor']) &&
    typeof config['usesDefaultHomeDesign'] === 'boolean' &&
    ['logoUrl', 'homeBackgroundUrl', 'homeHeroImageUrl', 'homeIntroText'].every(
      key => config[key] === null || typeof config[key] === 'string'
    ) &&
    Boolean(palette) &&
    SHADES.every(shade => isHex(palette?.[shade]))
  );
}
